<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="line" style="margin-bottom: 1.5rem;"></div>
        <full-calendar :options="calendarOptions" />

        <div class="form" style="padding: 1rem;">
          <div class="radio_line">
            <label class="radio">
              <input type="radio" name="requestTime" value="1" v-model="params.requestTime">
              <span class="label"><span>오전</span></span>
            </label>
            <label class="radio">
              <input type="radio" name="requestTime" value="2" v-model="params.requestTime">
              <span class="label"><span>오후</span></span>
            </label>
          </div>
        </div>

        <div class="small_notice">
          <div class="txt" style="margin: 0 auto;">
            <p><span style="font-size: 1.4rem;">필요 자료 안내</span></p>
          </div>
        </div>

        <div v-html="requireInfo" style="padding: 1rem; font-size: 1.2rem;">
        </div>

      </div>

      <div class="btn_wrap btn_wrap__fixed">
        <button class="btm on" @click="requestPerformance()">신청</button> <!--활성화: on-->
      </div>
    </div>
  </main>
</template>
<script>
import '@fullcalendar/core/vdom'; // solves problem with Vite
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

export default {
  components: {
    FullCalendar
  },
  data: function () {
    return {
      calendarOptions: {
        // selectable: true,
        // select: console.log,
        // longPressDelay: 1,
        locale: 'ko',
        height: 'auto',
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        headerToolbar: {
          start: 'prevYear prev', // will normally be on the left. if RTL, will be on the right
          center: 'title',
          end: 'next nextYear' // will normally be on the right. if RTL, will be on the left
        },
        dateClick: this.calendarDateClick,
      },
      requireInfo: '',
      params: {
        labNo: this.$route.query.labNo,
        requestDate: '',
        requestTime: ''
      }
    }
  },
  created: function () {
    this.getRequireInfo()
  },
  methods: {
    calendarDateClick: function (info) {
      this.params.requestDate = info.dateStr
      let dayEls = document.querySelectorAll('.fc-daygrid-day.fc-day')
      dayEls.forEach(dayEl => {
        dayEl.style.backgroundColor = 'white'
        dayEl.style.color = 'black'
      })
      info.dayEl.style.backgroundColor = '#1980C3'
      info.dayEl.style.color = 'white'
    },
    getRequireInfo: async function () {
      const res = await this.$LabSvc.getRequireInfo()
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.requireInfo = this.$Util.nl2br(entity)
      }
    },
    requestPerformance: async function () {
      if (this.params.requestDate === '') {
        this.$Util.modalAlert({message: '날자를 선택해 주세요.'})
        return false
      }
      if (this.params.requestTime === '') {
        this.$Util.modalAlert({message: '오전/오후를 선택해 주세요.'})
        return false
      }

      const res = await this.$LabSvc.requestPerformance(this.params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.$Util.modalAlert({message: '신청 되었습니다.'}, function () {
          this.$router.go(-1)
        })
      }
    }
  }
}
</script>
<style lang="scss">
.fc-toolbar-chunk {
  display: flex; // 일렬로 나란히
  align-items: center; // 수직 가운데 정렬
}
.fc-day-today {
  background-color: white !important;
}
</style>
